import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { LoginService, LoginRequest, SiteParams } from './login.service';

import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { EventMessage, EventType } from '@azure/msal-browser';
import { filter, switchMap } from 'rxjs/operators';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UiService } from '../core/ui.service';
import { AuthService } from '../core/auth';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false,
})
export class LoginComponent implements OnInit {
    #sanitizer = inject(DomSanitizer);
    #msalService = inject(MsalService);
    #msalBroadcastService = inject(MsalBroadcastService);
    #router = inject(Router);
    #route = inject(ActivatedRoute);
    #authService = inject(AuthService);
    #loginService = inject(LoginService);
    #uiService = inject(UiService);
    #destroyRef = inject(DestroyRef);

    loading: boolean = false;
    version: string = 'LOCAL';
    rememberCtrl: FormControl = new FormControl();

    customBranding: boolean;
    theme: string;
    allowCustomBranding = false;

    resetView: boolean;
    rpUsername: string;
    resetError: any;
    resetSuccess = false;
    externalApiHost: string;
    currentYear: number;
    accountId: string;

    eula: string;

    info: LoginRequest = {
        token: '',
    };

    isIframe = false;

    googleIframeUrl: SafeResourceUrl;

    siteParams: SiteParams;

    ngOnInit() {
        this.currentYear = new Date().getFullYear();

        this.isIframe = window !== window.parent && !window.opener;

        var rootHost = document.location.host;
        if (rootHost.indexOf('.') >= 0)
            rootHost = 'www' + rootHost.substring(rootHost.indexOf('.'));

        this.googleIframeUrl = this.#sanitizer.bypassSecurityTrustResourceUrl(
            'https://' + rootHost + '/googleauth.html#' + window.location.host.split('.')[0]
        );

        this.#route.queryParamMap.pipe(takeUntilDestroyed(this.#destroyRef)).subscribe((params) => {
            if (params.get('token')) {
                console.log('received token from external auth ' + params.get('token'));
                //params.get('token')
                this.#loginService
                    .loginWithGoogleToken(params.get('token'))
                    .then((user) => {
                        console.log(user);
                        this.loading = false;
                        if (this.#authService.getToken()) this.success();
                    })
                    .catch(() => {
                        alert('This user is not authorized to access this application');
                    });
            }
        });

        this.#msalBroadcastService.msalSubject$
            .pipe(
                filter(
                    (msg: EventMessage) =>
                        msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
                        msg.eventType === EventType.LOGIN_SUCCESS
                ),
                takeUntilDestroyed(this.#destroyRef)
            )
            .subscribe((result: EventMessage) => {
                console.log(result);
                this.loading = true;
                this.#loginService
                    .loginWithAzureToken((result.payload as any).idToken)
                    .then((user) => {
                        console.log(user);
                        this.loading = false;
                        if (this.#authService.getToken()) this.success();
                    })
                    .catch(() => alert('This user is not authorized to access this application'));
            });

        this.loading = true;
        this.#msalService
            .initialize()
            .pipe(
                switchMap(() => this.#loginService.getSiteParams()),
                takeUntilDestroyed(this.#destroyRef)
            )
            .subscribe({
                next: (p) => {
                    console.log('siteParams: ', p);
                    this.siteParams = p;
                    this.loading = false;
                },
                error: () => {
                    this.loading = false;
                },
            });

        this.#uiService
            .getVersion()
            .then((version) => {
                this.version = (version as string).replace('Staging-', '');
                console.log('Version: ', this.version);
            })
            .catch(() => {});
    }

    submit() {
        this.loading = true;

        this.#loginService
            .postLogin(this.info)
            .then(() => {
                this.loading = false;
                if (this.#authService.getToken()) this.success();
            })
            .catch(() => {});
    }

    loginWithMS() {
        this.#msalService
            .loginPopup({
                scopes: ['User.Read'],
                prompt: 'select_account',
                state: '_mssubdomain' + window.location.host.split('.')[0],
            })
            .pipe(takeUntilDestroyed(this.#destroyRef))
            .subscribe({
                next: (result) => {
                    console.log(result);
                },
                error: (error) => console.log(error),
            });
    }

    gapiSetup: any;
    authInstance: gapi.auth2.GoogleAuth;
    user: gapi.auth2.GoogleUser;

    logout() {}

    private success() {
        this.loading = false;
        this.navigateToDestination();
    }

    navigateToDestination() {
        let url = this.#authService.getSavedUrl();

        if (url) this.#router.navigateByUrl(url);
        else {
            this.#router.navigate(['home']);
        }
    }

    isKVSPortal: boolean = false;
    collectOemIdView: boolean = false;
    vsaUserDoesNotExistView: boolean = false;
    vsaActivationFailureView: boolean = false;
    vsaActivationSuccessView: boolean = false;
    twoFactorLogin: boolean = false;
    collectPasswordView: boolean = false;
    mapItcUserView: boolean = false;
    itcEnabled: boolean = false;
}
